<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-10 09:36:54
 * @LastEditTime: 2026-07-10 15:36:23
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 委托管控
 * @FilePath     : \src\views\platform\ICPS\internetSales\supplyManagement\preparatoryCommission\PreCommissioning.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div style="width: 100%">
          <!-- Tab 切换栏 -->
          <div class="tabtop" style="width: 380px; margin-bottom: 20px">
            <div v-for="(item, index) in typelist" :key="index" @click="choose(item.status)">
              <div :class="currenindex == item.status ? 'active' : 'text'">
                {{ item.value }}
              </div>
            </div>
          </div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">工程名称</span>
                  <el-input v-model="tableParam.engineeringName"
                    style="width: 180px; min-width: 150px; max-width: 220px" clearable placeholder="请输入"
                    @keyup.enter.native="gettableData()" />
                </span>
                <span style="display: inline-block; margin-left: 12px">
                  <span style="margin-right: 12px">销售员</span>
                  <el-select
                    v-model="tableParam.saller"
                    placeholder="请选择"
                    clearable
                    filterable
                    style="width: 150px"
                  >
                    <el-option
                      v-for="(item, index) in salesLeadsStatusList"
                      :key="index"
                      :label="item.saller"
                      :value="item.saller"
                    />
                  </el-select>
                </span>
                <span style="display: inline-block; margin-left: 12px">
                  <span style="margin-right: 12px">管控等级</span>
                  <el-select v-model="tableParam.controlLevel" style="width: 150px" clearable placeholder="请选择">
                    <el-option label="一级管控" :value="1" />
                    <el-option label="二级管控" :value="2" />
                    <el-option label="三级管控" :value="3" />
                  </el-select>
                </span>
                <span style="display: inline-block; margin-left: 12px">
                  <span style="margin-right: 12px">状态</span>
                  <el-select v-model="tableParam.controlStatus" style="width: 150px" clearable>
                    <el-option label="待风控" :value="1" />
                    <el-option label="已风控" :value="2" />
                    <el-option label="临时解控" :value="3" />
                  </el-select>
                </span>
                <span style="display: inline-block; margin-left: 12px">
                  <span style="margin-right: 12px">审批状态</span>
                  <el-select v-model="tableParam.approvalStatus" style="width: 150px" clearable>
                    <el-option label="无状态" :value="0" />
                    <el-option label="审核通过" :value="1" />
                    <el-option label="审批中" :value="2" />
                    <el-option label="审核失败" :value="3" />
                    <el-option label="撤销" :value="4" />
                  </el-select>
                </span>
                <el-button icon="el-icon-search" style="margin-left: 24px" size="medium" class="bottom_all"
                  @click="(tableParam.page = 1), gettableData()">查询</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div></div>
              <div>
                <el-link :underline="false" @click="load()">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_export1"></i>
                  </span>
                  导出
                </el-link>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                border stripe style="width: 100%" :height="screenHeight - 425" :data="tableData"
                tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :width="item.width" :fixed="item.fixed">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">
                        <el-link v-if="scope.row.controlStatus == 1" type="danger" :underline="false"
                          @click="getDelegatedHistory(scope.row)">待风控</el-link>
                        <el-link v-if="scope.row.controlStatus == 2" type="danger" :underline="false"
                          @click="getDelegatedHistory(scope.row)">已风控</el-link>
                        <el-link v-if="scope.row.controlStatus == 3" type="success" :underline="false"
                          @click="getDelegatedHistory(scope.row)">临时解控</el-link>
                      </span>
                      <span v-else-if="item.label == '审批状态'">
                        <span v-if="scope.row.approvalStatus == 0" @click="getDelegatedHistory(scope.row)">无状态</span>
                        <span v-if="scope.row.approvalStatus == 1" @click="getDelegatedHistory(scope.row)">审核通过</span>
                        <span v-if="scope.row.approvalStatus == 2" @click="getDelegatedHistory(scope.row)">审批中</span>
                        <span v-if="scope.row.approvalStatus == 3" @click="getDelegatedHistory(scope.row)">审核失败</span>
                        <span v-if="scope.row.approvalStatus == 4" @click="getDelegatedHistory(scope.row)">撤销</span>
                      </span>
                      <span v-else-if="item.label == '管控等级'">
                        <span v-if="scope.row.controlLevel == 1">一级管控</span>
                        <span v-if="scope.row.controlLevel == 2">二级管控</span>
                        <span v-if="scope.row.controlLevel == 3">三级管控</span>
                      </span>
                      <span v-else-if="item.label == '浇筑方式'">
                        {{ formatPourMethod(scope.row.pourMethod) }}
                      </span>
                      <span v-else-if="item.label == '委托期'">
                        {{ scope.row.entrustBeginTime }} ~ {{ scope.row.entrustEndTime }}
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-link v-if="scope.row.approvalStatus !== 2" type="danger" :underline="false"
                          @click="applyRemoveControl(scope.row)">申请解控</el-link>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
            :total="total" @size-change="sizeChange" @current-change="gettableData()" />
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>

      <!-- 申请解控对话框 -->
      <el-dialog :visible.sync="removeControlDig" width="1140px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">申请解控</span>
        <el-descriptions :column="2" border class="descriptions" label-width="200">
          <el-descriptions-item label="申请日期：">{{ formData.createTime }}</el-descriptions-item>
          <el-descriptions-item label="工程名称：">{{ formData.engineeringName }}</el-descriptions-item>
          <el-descriptions-item label="合同单位：">{{ formData.companyName }}</el-descriptions-item>
          <el-descriptions-item label="委托类型：">
            <el-select v-model="formData.delegationType" placeholder="请选择委托类型" clearable filterable @change="handleDelegationTypeChange" >
              <el-option
                v-for="item in delegationTypeOptions"
                :key="item.id"
                :label="item.itemName"
                :value="item.itemName"
              />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="交底类型：">{{ formData.discloseType }}</el-descriptions-item>
          <el-descriptions-item label="首次供应时间：">{{ formData.firstSupplyTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="委托日期：">{{ formData.entrustBeginTime }} ~ {{ formData.entrustEndTime }}</el-descriptions-item>
          <el-descriptions-item label="累计委托量：">{{ formData.commissionedQuantity }}</el-descriptions-item>
          <el-descriptions-item label="截至审核日已供方量（m³）：" :span="2">{{ formData.supplyQuantity }}</el-descriptions-item>
          <el-descriptions-item label="本次申请委托量（m³）：">
            <el-input
              v-model="formData.applyEntrustedVolume"
              placeholder="请输入正整数"
              @input="handlePositiveInteger('applyEntrustedVolume', $event)"
            />
          </el-descriptions-item>
          <el-descriptions-item label="本次申请委托截至时间：">
            <el-date-picker
              v-model="formData.applyDeadlineDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-descriptions-item>
          <el-descriptions-item label="累计委托量（m³）">
            {{ calculateTotalCommissioned(formData.commissionedQuantity, formData.applyEntrustedVolume) }}
          </el-descriptions-item>
          <el-descriptions-item label="查看管控参数">
            <span><el-link :underline="false" @click="lookMore">查看</el-link></span>
          </el-descriptions-item>
          <el-descriptions-item label="需办理委托原因与合同推进情况与预计签订时间简述:"
            labelClassName="redFont" contentClassName="textClass" :span="2">
            <el-input v-model="formData.argument" :disabled="isLook" placeholder="请输入" type="textarea" style="width: 100%" />
          </el-descriptions-item>
          <el-descriptions-item label="附件：" :span="2">
            <FileComponent fileCode="settlementFile" :disabled="isLook" :files="files" @deleteFile="deleteFile"
              @uplodeSuccess="uplodeSuccess" />
          </el-descriptions-item>
        </el-descriptions>

        <!-- 核订单签订情况 -->
        <span style="font-size: 18px; margin-top: 24px">核订单签订情况</span>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%; margin-top: 12px" tooltip-effect="dark" :data="nuclearOrderTableData">
          <el-table-column label="结算周期" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.lastDueTime }} ~ {{ scope.row.currentDueTime }}
            </template>
          </el-table-column>
          <el-table-column label="结算量" align="center" prop="settleAmount" width="120" />
          <el-table-column label="审核状态" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.settleStatus == 0">待结算</span>
              <span v-if="scope.row.settleStatus == 1">待审核</span>
              <span v-if="scope.row.settleStatus == 2">审核中</span>
              <span v-if="scope.row.settleStatus == 3">审核不通过</span>
              <span v-if="scope.row.settleStatus == 4">审核通过</span>
            </template>
          </el-table-column>
          <el-table-column label="附件" align="center">
            <template slot-scope="scope">
              <el-link v-if="scope.row.enclosureUrl" type="primary" :underline="false"
                @click="viewAttachment(scope.row.enclosureUrl)">查看附件</el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="openSettlementDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <span style="font-size: 18px; margin-top: 24px">历史申请流程</span>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%; margin-top: 12px" tooltip-effect="dark" :data="removeControlTableData">
          <el-table-column label="申请时间" align="center" prop="createTime" width="160" />
          <el-table-column label="申请人" align="center" prop="createUserName" width="70" />
          <el-table-column label="历史累计委托量" align="center" prop="commissionedQuantity" width="auto" />
          <el-table-column label="累计供应量" align="center" prop="supplyQuantity" width="auto" />
          <!-- <el-table-column label="本次委托截止时间" align="center" prop="applyDeadlineDate" width="100" />
          <el-table-column label="本次申请委托量" align="center" prop="applyEntrustedVolume" width="160" />
          <el-table-column label="累计委托量" align="center" prop="lastCommissionedQuantity" width="160" /> -->
          <el-table-column label="本次委托截止时间" align="center" prop="leaderDeadlineDate" width="100" />
          <el-table-column label="本次申请委托量" align="center" prop="leaderEntrustedVolume" width="160" />
          <el-table-column label="累计委托量" align="center" prop="leaderCommissionedQuantity" width="160" />
          <el-table-column label="流程完成时间" align="center" prop="approvalTime" width="160" />
          <el-table-column label="审批状态" align="center" prop="approvalStatus" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.approvalStatus == 0">无状态</span>
              <span v-if="scope.row.approvalStatus == 1">审核通过</span>
              <span v-if="scope.row.approvalStatus == 2">审批中</span>
              <span v-if="scope.row.approvalStatus == 3">审核失败</span>
              <span v-if="scope.row.approvalStatus == 4">撤销</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="220">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">查看</el-button>
              <el-button size="mini" class="bottom_two" @click="printApproval(scope.row)">打印审批表</el-button>
            </template>
          </el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="removeControlDig = false">关闭</el-button>
          <el-button class="bottom_all" @click="submitRemoveControl">提交</el-button>
        </span>
      </el-dialog>

      <!-- 历史记录明细对话框 -->
      <el-dialog :visible.sync="historyDetailDig" width="1080px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">申请解控详情</span>
        <el-descriptions :column="2" border class="descriptions" label-width="200">
          <el-descriptions-item label="申请日期：">{{ historyDetailForm.createTime }}</el-descriptions-item>
          <el-descriptions-item label="工程名称：">{{ historyDetailForm.engineeringName }}</el-descriptions-item>
          <el-descriptions-item label="合同单位：">{{ historyDetailForm.companyName }}</el-descriptions-item>
          <el-descriptions-item label="委托类型：">{{ historyDetailForm.delegationType }}</el-descriptions-item>
          <el-descriptions-item label="交底类型：">{{ historyDetailForm.discloseType }}</el-descriptions-item>
          <el-descriptions-item label="首次供应时间：">{{ historyDetailForm.firstSupplyTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="委托日期：">{{ historyDetailForm.entrustBeginTime }} ~ {{ historyDetailForm.entrustEndTime }}</el-descriptions-item>
          <el-descriptions-item label="累计委托量：">{{ historyDetailForm.commissionedQuantity }}</el-descriptions-item>
          <el-descriptions-item label="截至审核日已供方量（m³）：" :span="2">{{ historyDetailForm.supplyQuantity }}</el-descriptions-item>
          <el-descriptions-item label="本次申请委托量（m³）：">{{ historyDetailForm.applyEntrustedVolume }}</el-descriptions-item>
          <el-descriptions-item label="本次申请委托截至时间：">{{ historyDetailForm.applyDeadlineDate }}</el-descriptions-item>
          <el-descriptions-item label="累计委托量（m³）">{{ calculateTotalCommissioned(historyDetailForm.commissionedQuantity, historyDetailForm.applyEntrustedVolume) }}</el-descriptions-item>
          <el-descriptions-item label="查看管控参数">
            <span><el-link :underline="false" @click="lookMore">查看</el-link></span>
          </el-descriptions-item>
          <el-descriptions-item label="需办理委托原因与合同推进情况与预计签订时间简述:"
            labelClassName="redFont" contentClassName="textClass" :span="2">
            <el-input v-model="historyDetailForm.argument" :disabled="true" placeholder="请输入" type="textarea" style="width: 100%" />
          </el-descriptions-item>
          <el-descriptions-item label="附件：" :span="2">
            <FileComponent fileCode="settlementFile" :disabled="true" :files="files2" />
          </el-descriptions-item>
        </el-descriptions>

        <span style="font-size: 18px">领导审批参数</span>
        <el-descriptions :column="2" border class="descriptions" label-width="200" style="margin-bottom: 24px;margin-top:12px">
          <el-descriptions-item  label="本次申请委托时间：" labelClassName="redFont"> 
            {{historyDetailForm.leaderDeadlineDate }}
            <!-- <el-date-picker v-model="historyDetailForm.leaderDeadlineDate" style="width: 150px" type="date" unlink-panels value-format="yyyy-MM-dd" /> -->
          </el-descriptions-item>
          <el-descriptions-item  label="本次申请累计委托量（m³）" labelClassName="redFont">{{
            historyDetailForm.leaderEntrustedVolume
          }}</el-descriptions-item>
            <el-descriptions-item  label="累计委托量（m³）" labelClassName="redFont">{{
              historyDetailForm.leaderCommissionedQuantity
          }}</el-descriptions-item>
        </el-descriptions>

        <!-- 核订单签订情况 -->
        <span style="font-size: 18px; margin-top: 24px">核订单签订情况</span>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%; margin-top: 12px" tooltip-effect="dark" :data="nuclearOrderTableData">
          <el-table-column label="结算周期" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.lastDueTime }} ~ {{ scope.row.currentDueTime }}
            </template>
          </el-table-column>
          <el-table-column label="结算量" align="center" prop="settleAmount" width="120" />
          <el-table-column label="审核状态" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.settleStatus == 0">待结算</span>
              <span v-if="scope.row.settleStatus == 1">待审核</span>
              <span v-if="scope.row.settleStatus == 2">审核中</span>
              <span v-if="scope.row.settleStatus == 3">审核不通过</span>
              <span v-if="scope.row.settleStatus == 4">审核通过</span>
            </template>
          </el-table-column>
          <el-table-column label="附件" align="center">
            <template slot-scope="scope">
              <el-link v-if="scope.row.enclosureUrl" type="primary" :underline="false"
                @click="viewAttachment(scope.row.enclosureUrl)">查看附件</el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="openSettlementDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <FlowsNodeList :tableData="approveTableData" />

        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="historyDetailDig = false">关闭</el-button>
        </span>
      </el-dialog>

      <!-- 历史记录列表对话框 -->
      <el-dialog title="历史记录" :visible.sync="historyDig" width="1140px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%; margin-top: 12px" tooltip-effect="dark" :data="removeControlTableData">
          <el-table-column label="申请时间" align="center" prop="createTime" width="160" />
          <el-table-column label="申请人" align="center" prop="createUserName" width="70" />
          <el-table-column label="历史累计委托量" align="center" prop="commissionedQuantity" width="auto" />
          <el-table-column label="累计供应量" align="center" prop="supplyQuantity" width="auto" />
          <el-table-column label="本次委托截止时间" align="center" prop="leaderDeadlineDate" width="100" />
          <el-table-column label="本次申请委托量" align="center" prop="leaderEntrustedVolume" width="160" />
          <el-table-column label="累计委托量" align="center" prop="leaderCommissionedQuantity" width="160" />
          <!-- <el-table-column label="本次委托截止时间" align="center" prop="applyDeadlineDate" width="100" />
          <el-table-column label="本次申请委托量" align="center" prop="applyEntrustedVolume" width="160" />
          <el-table-column label="累计委托量" align="center" prop="lastCommissionedQuantity" width="160" /> -->
          <el-table-column label="流程完成时间" align="center" prop="approvalTime" width="160" />
          <el-table-column label="审批状态" align="center" prop="approvalStatus" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.approvalStatus == 0">无状态</span>
              <span v-if="scope.row.approvalStatus == 1">审核通过</span>
              <span v-if="scope.row.approvalStatus == 2">审批中</span>
              <span v-if="scope.row.approvalStatus == 3">审核失败</span>
              <span v-if="scope.row.approvalStatus == 4">撤销</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="220">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">查看</el-button>
              <el-button size="mini" class="bottom_two" @click="printApproval(scope.row)">打印审批表</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="historyDig = false">关闭</el-button>
        </span>
      </el-dialog>

      <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
      <ControlParamDialog :visible.sync="controlParamVisible" :rowData="currentRow" />
      <PrintApprovalDialog :visible.sync="printApprovalVisible" :rowData="currentPrintRow" :companyName="currentCompanyName" />
      <!-- 结算详情弹窗（过程核定量） -->
      <settlement-detail-dialog  v-model="settlementDetailVisible"  :rowData="currentRowData"/>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  delegatedControlQuery,
  queryDelegatedHistory,
  delegatedControlDownload as Download,
  quryApplyData,
  dataVerification,
  // saveDelegatedHistory
} from "@/api/internetSales/supplyManagement.js";
import { querySales } from "@/api/internetSales/monthlyReportUnitRecord.js";
import { getDicType } from "@/api/common.js";
import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import FlowsNodeList from "@/components/WorkFlow/flowsNodeList";
import { getNodeList } from "@/api/task/flows";
import LookFile from "@/components/File/LookFile";
import ControlParamDialog from "@/views/platform/ICPS/internetSales/supplyManagement/preparatoryCommission/components/ControlParam";
import PrintApprovalDialog from "@/views/platform/ICPS/internetSales/supplyManagement/preparatoryCommission/components/PrintApproval";
import SettlementDetailDialog from "@/views/platform/ICPS/internetSales/supplyManagement/preparatoryCommission/components/SettlementDetail";
import { getUserInfo } from "@/utils/auth.js";

export default {
  components: {
    FileComponent,
    FlowsNodeList,
    LookFile,
    ControlParamDialog,
    PrintApprovalDialog,
    SettlementDetailDialog,
  },
  mixins: [mixin],
  data() {
    return {
      currenindex: 1,
      currentCompanyName:"",
      typelist: [
        { value: "进行中", status: 1 },
        { value: "历史委托", status: 2 }
      ],
      table: [
        { label: "工程ID", prop: "engineeringId", status: true, width: "180", fixed: "left" },
        { label: "工程名称", prop: "engineeringName", status: true, width: "280", fixed: "left" },
        { label: "合同单位", prop: "businesName", status: true, width: "220" },
        { label: "签订主体", prop: "collaborationUnitName", status: true, width: "160" },
        { label: "协调主体", prop: "coordinationSubject", status: true, width: "160" },
        { label: "交底类型", prop: "discloseType", status: true, width: "120" },
        { label: "委托类型", prop: "delegationType", status: true, width: "120" },
        { label: "施工进度", prop: "constructionProgress", status: true, width: "120" },
        { label: "销售员", prop: "saller", status: true, width: "120" },
        { label: "委托期", prop: "", status: true, width: "180" },
        { label: "累计委托量", prop: "commissionedQuantity", status: true, width: "100" },
        { label: "累计供应量", prop: "supplyQuantity", status: true, width: "100" },
        { label: "管控等级", prop: "controlLevel", status: true, width: "120" },
        { label: "状态", prop: "controlStatus", status: true, width: "120" },
        { label: "审批状态", prop: "approvalStatus", status: true, width: "120" },
        { label: "审批时间", prop: "approvalTime", status: true, width: "150" },
        { label: "操作", prop: "", status: true, width: "120" }
      ],
      DownloadURL: Download,
      tableData: [],
      pagesType: 0,
      tableParam: {
        page: 1,
        pageSize: 10,
        dataType: 1,
        engineeringName: "",
        saller: "",
        controlStatus: "",
        controlLevel: "",
        approvalStatus: ""
      },
      salesLeadsStatusList: [],
      formData: {
        mainDataId: '', //取外层id
        id: '',
        engineeringId: '',
        engineeringName: '',
        companyId: '',
        companyName: '',
        delegationType: '',
        delegationTypeId: '',
        entrustBeginTime: '',
        entrustEndTime: '',
        commissionedQuantity: 0,
        supplyQuantity: 0,
        firstSupplyTime: '',
        businesName: '',
        collaborationUnitName: '',
        coordinationSubject: '',
        discloseType: '',
        constructionProgress: '',
        saller: '',
        applyDeadlineDate: '',
        applyEntrustedVolume: '',
        argument: '',
        createTime: '',           // 仅展示
        attachment: []            // 存储文件对象数组
      },
      historyDetailForm: {},
      files: [],
      files2: [],
      confirmFiles: [],
      isLook: false,
      removeControlDig: false,
      historyDetailDig: false,
      controlParamVisible: false,
      printApprovalVisible: false,
      settlementDetailVisible: false,
      currentRowData:{},
      currentPrintRow: {},
      currentRow: {},
      low: {},
      approveTableData: [],
      userRealName: "",
      removeControlTableData: [],
      nuclearOrderTableData: [],
      historyDig: false,
      dataType: 1,
      lookFileVisible: false,
      lookFileConfig: { filePaths: "" },
      total: 0,
      tableLoading: false,
      screenHeight: window.innerHeight,
      style: {},
      showCardNav: true,
      delegationTypeOptions: []
    };
  },
  async created() {
    this.tableParam.dataType = 1;
    this.tableParam.saller = await getUserInfo().userRealName;
    this.gettableData(true);
    querySales().then(res => {
      if (res.code == 1001) {
        this.salesLeadsStatusList = res.data;
      }
    });
  },
  methods: {
    choose(num) {
      this.currenindex = num;
      this.tableParam.page = 1;
      this.tableParam.dataType = this.currenindex === 1 ? 1 : 2;
      this.tableParam.engineeringName = '';
      this.tableParam.saller = '';
      this.tableParam.controlStatus = '';
      this.tableParam.controlLevel = '';
      this.tableParam.approvalStatus = '';
      this.gettableData();
    },
    calculateTotalCommissioned(base, add) {
      return (Number(base) || 0) + (Number(add) || 0);
    },
    handleDelegationTypeChange(val) {
      if (!val) {
        this.formData.delegationTypeId = '';
        return;
      }
      const selectedOption = this.delegationTypeOptions.find(item => item.itemName === val);
      if (selectedOption) {
        this.formData.delegationTypeId = selectedOption.id;
      } else {
        this.formData.delegationTypeId = '';
      }
    },
    formatPourMethod(val) {
      if (!val) return '-';
      const data = typeof val === 'string' ? JSON.parse(val) : val;
      if (Array.isArray(data)) {
        return data.map(item => item.name).filter(n => n).join(' / ') || '-';
      }
      if (data && data.name) {
        return data.name;
      }
      return '-';
    },
    handleWhetherReleaseChange(val) {
      if (val === 1) {
        this.formData.releaseControlTime = '';
      }
    },
    lookFile(row) {
      this.lookFileConfig.filePaths = row.attachment;
      this.lookFileVisible = true;
    },
    openSettlementDetail(row) {
      this.currentRowData = {
        ...row,
        engineeringName: this.formData.engineeringName,
        engineeringId: this.formData.engineeringId,
      };
      console.log(this.currentRowData);
      this.settlementDetailVisible = true;
    },
    lookDetail(row) {
      this.historyDetailForm = row;
      let params = {
        processManagerId: row.processManagerId,
        processTaskId: row.processTaskId,
        processVersionId: row.processVersionId
      };
      getNodeList(params).then(res => {
        if (res.code === 1001) {
          const newData = [];
          res.data.forEach(item => {
            const data = {
              nodeName: item.nodeName,
              userName: item.instanceLogsList.map(sItem => sItem.userName),
              userId: item.instanceLogsList.map(sItem => sItem.userId),
              multiApprovalType: item.multiApprovalType,
              approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
              handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
              id: item.id,
              approvalStatus: item.approvalStatus,
              processInstanceId: item.processInstanceId,
              processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId),
            };
            newData.push(data);
          });
          this.approveTableData = newData;
        }
      });
      this.historyDetailDig = true;
    },
    handlePositiveInteger(field, value) {
      let str = String(value || "");
      str = str.replace(/[^\d]/g, "");
      if (str === "") str = "0";
      let intVal = parseInt(str, 10);
      if (intVal < 0) intVal = 0;
      this.formData[field] = intVal;
    },
    loadDelegationTypes() {
      if (this.delegationTypeOptions.length) return Promise.resolve();
      return getDicType({ code: "delegation_type" }).then(res => {
        if (res.code === 1001 && res.data && res.data.items) {
          this.delegationTypeOptions = res.data.items;
        } else {
          this.$message.error("获取委托类型失败");
        }
      });
    },
    uplodeSuccess(data) {
      const params = {
        fileName: data.fileName,
        filePath: data.fileUrl,
      };
      this.files.push(params);
      this.formData.attachment = JSON.stringify(this.files);
    },
    deleteFile(index) {
      this.files.splice(index, 1);
      this.formData.attachment = JSON.stringify(this.files);
    },
    gettableData() {
      this.tableLoading = true;
      delegatedControlQuery(this.tableParam).then(res => {
        this.tableLoading = false;
        if (res.code == 1001) {
          this.total = res.data.totalRows;
          this.tableData = res.data.data;
          if (!this.tableParam.dataMouth && res.data.data && res.data.data.length > 0) {
            this.tableParam.dataMouth = res.data.data[0].dataMouth;
          }
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    applyRemoveControl(row) {
      this.loadDelegationTypes().then(() => {
        const initialFormData = this.$options.data().formData;
        Promise.all([
          queryDelegatedHistory({ mainDataId: row.id }),
          quryApplyData({ engineeringId: row.engineeringId })
        ]).then(([historyRes, applyRes]) => {
          if (historyRes.code == 1001) {
            this.removeControlTableData = historyRes.data.historyList || [];
          }
          let supply = 0, firstTime = '';
          if (applyRes.code == 1001) {
            supply = applyRes.data.supplyQuantity || 0;
            firstTime = applyRes.data.firstSupplyTime || '';
            this.nuclearOrderTableData = applyRes.data.processManageVos || [];
          }
          this.formData = {
            ...initialFormData,
            ...row,
            supplyQuantity: supply,
            firstSupplyTime: firstTime,
            attachment: row.attachment ? JSON.parse(row.attachment) : []
          };
          this.formData.mainDataId =  row.id;

          this.files = this.formData.attachment;
          this.removeControlDig = true;
        }).catch(err => {
          this.$message.error('获取数据失败：' + (err.message || '未知错误'));
        });
      });
    },
    submitRemoveControl() {
      if (!this.formData.applyEntrustedVolume || this.formData.applyEntrustedVolume <= 0) {
        this.$message.error('请输入本次申请委托量（正整数）');
        return;
      }
      if (!this.formData.applyDeadlineDate) {
        this.$message.error('请选择本次申请委托截至时间');
        return;
      }
      if (!this.formData.delegationType) {
        this.$message.error('请选择委托类型');
        return;
      }
      dataVerification({
        mainDataId: this.formData.id,
        applyDeadlineDate: this.formData.applyDeadlineDate,
        applyEntrustedVolume: this.formData.applyEntrustedVolume
      }).then(res => {
        if (res.code === 1001) {
          const verifyData = res.data;
          if (verifyData.whetherSubmit === 1) {
            const lastCommissionedQuantity = (Number(this.formData.commissionedQuantity) || 0) + (Number(this.formData.applyEntrustedVolume) || 0);
            // 将需要提交的字段直接附加到 formData 上
            this.formData.attachment = JSON.stringify(this.files);
            this.formData.lastCommissionedQuantity = lastCommissionedQuantity;
            this.formData.controlLevel = verifyData.controlLevel;
            console.log(this.formData)
            this.$router.push({
              name: "PreCommissioningApproval",
              query: {
                formData: JSON.stringify(this.formData),
                dataContent: JSON.stringify(this.formData),
                type: 1,
              }
            });
            // saveDelegatedHistory(this.formData).then(saveRes => {
            //   if (saveRes.code === 1001) {
            //     let newId = saveRes.data.id
            //     this.formData.id = newId
            //     console.log('res.data',saveRes.data)
            //     console.log('console',this.formData)
            //     this.$router.push({
            //       name: "PreCommissioningApproval",
            //       query: {
            //         formData: JSON.stringify(this.formData),
            //         dataContent: JSON.stringify(this.formData),
            //         type: 1,
            //       }
            //     });
            //   } else {
            //     this.$message.error(saveRes.codeMsg || '保存失败');
            //   }
            // })
          } else {
            this.$message.error(verifyData.hint);
          }
        } 
      })
    },
    getDelegatedHistory(row) {
      this.currentCompanyName =  row.companyName || '';
      queryDelegatedHistory({ mainDataId: row.id }).then(res => {
        if (res.code == 1001) {
          this.formData = JSON.parse(JSON.stringify(row));
          this.low = JSON.parse(JSON.stringify(row));
          this.removeControlTableData = res.data.historyList;
          this.historyDig = true;
        }
      });
    },
    viewAttachment(enclosureUrl) {
      if (!enclosureUrl) return;
      try {
        const files = JSON.parse(enclosureUrl);
        if (files && files.length) {
          this.lookFileConfig.filePaths = JSON.stringify(files);
          this.lookFileVisible = true;
        } else {
          this.$message.info('无附件');
        }
      } catch (e) {
        this.$message.error('附件解析失败');
      }
    },
    printApproval(row) {
      console.log('打印审批表')
      console.log(row)
      this.currentPrintRow = row;
      this.printApprovalVisible = true;
    },
    lookMore() {
      this.currentRow = {
        companyId: this.formData.companyId,
        delegationTypeId: this.formData.delegationTypeId,
      };
      this.controlParamVisible = true;
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    init() {
      this.tableParam = this.$options.data().tableParam;
      this.tableParam.dataType = this.currenindex === 1 ? 1 : 2;
      this.gettableData();
    },
  }
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.textCss {
  display: flex;
  align-items: center;
  text-align: center;
}
.tabtop {
  width: 378px;
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  > div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    .text {
      width: 188px;
      line-height: 40px;
      color: $bg_color;
    }
    .active {
      width: 188px;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }
    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}
</style>
<style scoped>
.descriptions *>>> .redFont {
  color: red !important;
}
.descriptions *>>> .textClass {
  width: 450px;
}
.descriptions *>>> .textClass2 {
  width: 300px;
}
</style>